import { render, staticRenderFns } from "./AdminProfitElement.vue?vue&type=template&id=27aae6ef&scoped=true"
import script from "./AdminProfitElement.vue?vue&type=script&lang=js"
export * from "./AdminProfitElement.vue?vue&type=script&lang=js"
import style0 from "./AdminProfitElement.vue?vue&type=style&index=0&id=27aae6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aae6ef",
  null
  
)

export default component.exports